
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({
    
    totalGastos: 0,
    
});




export const useGastosStore = create()(
    devtools(
        storeApi
    )
)
